<template>  
  <v-radio-group row dense :value="content" v-on:change="callChange" class="mt-1">
    <v-radio key='0' label="Percentage (%)" value='P'></v-radio>
    <v-radio key='1' label="Amount (€)" value='A'></v-radio>
    <v-radio key='2' label="Weekprice (€)" value='W' v-if="showWeekPriceOption===true"></v-radio>
    <v-radio key='3' label="Night(s)" value='N' v-if="showNightsOption===true"></v-radio>
  </v-radio-group>
</template>
  
<script>
  export default {
   
    props: {
      field: String,
      value: String,
      showWeekPriceOption: {
        type: Boolean,
        default: false,
      },
      showNightsOption: {
        type: Boolean,
        default: false,
      }        
    },
    data() {
      return {
        content: this.value
      }
    },    
    methods:{
      callChange(data){
          this.$emit('updateData', {"field": this.field, "value": data});
      },    
    }
  }
</script>
  
<style scoped>
  
</style>